interface ScrollToFirstErrorOptions {
  offset?: number;
  behavior?: ScrollBehavior;
  selector?: string;
}

/**
 * Scrolls to the first error field in the form.
 *
 * @param options - Configuration options
 * @param options.offset - Vertical offset from the top of the element (default: -100)
 * @param options.behavior - Scroll behavior (default: 'smooth')
 * @param options.selector - CSS selector for error elements (default: '[aria-invalid="true"]')
 */
export const scrollToFirstError = ({
  offset = -100,
  behavior = 'smooth',
  selector = '[aria-invalid="true"]',
}: ScrollToFirstErrorOptions = {}) => {
  const errorElements = document.querySelectorAll(selector);
  if (errorElements.length === 0) return;

  const sortedElements = Array.from(errorElements).sort((a, b) => {
    const positionA = a.getBoundingClientRect().top;
    const positionB = b.getBoundingClientRect().top;
    return positionA - positionB;
  });

  const firstElement = sortedElements[0];
  if (firstElement) {
    const y = firstElement.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ behavior, top: y });
  }
};
